'use strict'

import axios from 'axios'

import {
  ConfigService
} from '@nuskin/ns-util'

import { 
  CartService 
} from '@nuskin/ns-shop'

let makeAxiosRequest = async (method, url, data) => {
  try {
    let awsUrl = ConfigService.getMarketConfig().awsUrl 

    if (!awsUrl) {
      return false
    }
  
    return await axios({
      method: method,
      url: awsUrl + url,
      data: data
    })
      .then(result => {
        if (typeof(result.data) === 'object') {
          return result.data
        }
        return JSON.parse(result.data)
      })
  } catch (err) {
    console.log(err)
    return []
  }
}

let getRecommendations = async () => {
  let cartContentsParam = encodeURI(JSON.stringify(CartService.getItemData().map(x => x.sku)))
  let market = 'market=' + ConfigService.getMarketConfig().markets
  let url = '/product-recommendation/v1/recommendations?cartContents=' + cartContentsParam + '&' + market

  let queryResult = await makeAxiosRequest('GET', url, null)
  if (queryResult && queryResult.data) {
    return queryResult.data
  }
  return []
}

export {
  getRecommendations
}